import type {
  BulkSupplyPointRevisionDto,
  BulkSupplyPointResult,
  CreateSupplyPointRevisionDto,
  SerializedSupplyPoint,
  SerializedSupplyPointHistory,
  SerializedSupplyPointRevision,
  UpdateSupplyPointRevisionDto,
} from '@enmon/commons/lib/enmon';
import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';

// Argument types
export type GetSupplyPointHistoryArg = SerializedSupplyPoint['_id'];

export type CreateSupplyPointRevisionArg = {
  supplyPointId: SerializedSupplyPoint['_id'];
  body: CreateSupplyPointRevisionDto;
};

export type UpdateSupplyPointRevisionArg = {
  supplyPointId: SerializedSupplyPoint['_id'];
  revisionId: SerializedSupplyPointRevision['_id'];
  body: UpdateSupplyPointRevisionDto;
};

// Result types
export type GetSupplyPointHistoryResult = SerializedSupplyPointHistory | null;
export type CreateSupplyPointRevisionResult = SerializedSupplyPointRevision | null;
export type UpdateSupplyPointRevisionResult = SerializedSupplyPointRevision | null;
export type BulkSupplyPointRevisionsResult = BulkSupplyPointResult | null;

export class SupplyPointRevisionsApiClient extends BaseApiClient {
  constructor() {
    super('api/supply-points');
  }

  public async getHistory(
    supplyPointId: GetSupplyPointHistoryArg,
    signal: RequestOptions['signal'],
  ): Promise<GetSupplyPointHistoryResult> {
    return await this.http.get(`${supplyPointId}/revisions/history`, { signal });
  }

  public async create({ supplyPointId, body }: CreateSupplyPointRevisionArg): Promise<CreateSupplyPointRevisionResult> {
    return await this.http.post(`${supplyPointId}/revisions`, body);
  }

  public async update({
    supplyPointId,
    revisionId,
    body,
  }: UpdateSupplyPointRevisionArg): Promise<UpdateSupplyPointRevisionResult> {
    return await this.http.patch(`${supplyPointId}/revisions/${revisionId}`, body);
  }

  public async previewBulk(body: BulkSupplyPointRevisionDto): Promise<BulkSupplyPointRevisionsResult> {
    return await this.http.post('revisions/bulk/preview', body);
  }

  public async createBulk(body: BulkSupplyPointRevisionDto): Promise<BulkSupplyPointRevisionsResult> {
    return await this.http.post('revisions/bulk', body);
  }
}
